<div id="public-self-disclosure" class="watermark py-5">
  <div class="container-fluid px-lg-5">

    <!-- Section Heading -->
    <h2 class="title text-center mb-4">Public Self-Disclosure</h2>
    
    <p class="psd-lead text-center mb-5">
      In compliance with regulatory requirements, Shah Satnam Ji Girls' College publishes the constitution and details of its active committees, cells, and mandatory public self-disclosures. Below you can find and download the official PDF documents for each academic session.
    </p>

    <!-- Table Container -->
    <div class="row justify-content-center">
      <div class="col-12 col-xl-10">
        
        <div class="psd-table-wrapper shadow-sm rounded overflow-hidden">
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead class="psd-table-header">
                <tr>
                  <th scope="col" class="text-center" style="width: 80px;">S.No.</th>
                  <th scope="col">Document Title</th>
                  <th scope="col" class="text-center" style="width: 160px;">Session / Year</th>
                  <th scope="col" class="text-center" style="width: 200px;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of documents; let i = index">
                  <td class="text-center fw-bold text-muted">{{ i + 1 }}</td>
                  <td>
                    <div class="d-flex align-items-center gap-3">
                      <span class="psd-file-icon">
                        <i class="fa-solid fa-file-pdf"></i>
                      </span>
                      <span class="psd-doc-name fw-semibold">{{ doc.name }}</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <span class="badge psd-year-badge" [class.badge-general]="doc.year === 'General'">{{ doc.year }}</span>
                  </td>
                  <td class="text-center">
                    <a [href]="doc.path" target="_blank" class="psd-download-btn">
                      <i class="fa-solid fa-cloud-arrow-down me-1"></i> Download PDF
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
